<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)">
		<div class="ld-panel-title">
			<h2 class="back-btn">预警推送</h2>
		</div>
		<div class="ld-panel-main">
			<el-button type="primary" class="add" @click="addChange">添加规则</el-button>
			<div class="search-main clear">
				<el-input v-model="searchInput" class="input" placeholder="请输入搜索内容..." clearable @clear="handleEmpty"></el-input>
				<span @click="searchClick" class="btn"></span>
			</div>
			<el-table :data="tableData" v-loading="loading" style="width: 100%">
				<el-table-column label="实例 ID(名称)" width="240">
					<template #default="scope">
						<span class="instance_name">{{scope.row.instance_id}}</span>
						<span v-if="scope.row.instance_name">({{scope.row.instance_name}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="alarm_name" label="规则名称" />
				<el-table-column prop="filed_name" label="推送类型" />
				<el-table-column prop="maximum_value" label="推送最大值" />
				<el-table-column prop="minimum_value" label="推送最小值" />
				<el-table-column label="是否启用">
					<template #default="scope">
						<el-switch v-show="scope.row.loading" loading v-model="scope.row.status" />
						<el-switch v-show="!scope.row.loading" @click="switchChange(scope.row,scope.$index)" v-model="scope.row.status" />
					</template>
				</el-table-column>
				<el-table-column label="操作" width="110">
				  <template #default="scope">
					<el-button link type="primary" size="small" v-if="!scope.row.status" @click="rowOperation(scope.row,'edit')">编辑</el-button>
					<el-button link type="danger" size="small" v-if="!scope.row.status" @click="rowOperation(scope.row,'delete')">删除</el-button>
				  </template>
				</el-table-column>
			</el-table>
			<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
		</div>
		<!-- 添加规则 -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogGroupVisible" title="添加规则">
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
				<el-form-item label="所属实例" prop="instance_id">
					<el-select v-model="groupForm.instance_id">
						<el-option v-for="item in exampleOptions" :key="item.instance_id" :value="item.instance_id" :label="item.instance_name +'('+item.instance_id+')'"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="规则名称" prop="alarm_name">
					<el-input v-model="groupForm.alarm_name" autocomplete="off" />
				</el-form-item>
				<el-form-item label="推送类型" prop="fileds">
					<el-select value-key="name" v-model="groupForm.fileds" @change="filedChange">
						<el-option v-for="item in filedOptions" :key="item.name" :value="item" :label="item.desc"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="最大值" prop="maximum_value">
					<el-input v-model="groupForm.maximum_value" autocomplete="off" />
				</el-form-item>
				<el-form-item label="最小值" prop="minimum_value">
					<el-input v-model="groupForm.minimum_value" autocomplete="off" />
				</el-form-item>
				<el-form-item label="验证码" prop="code" v-if="!editFlag">
					<el-input v-model="groupForm.code" style="width: 300px; margin-right: 8px;" />
					<el-button type="primary" :disabled="codeSend" @click="codeChange">{{codeSendText}}</el-button>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetForm(ruleFormRef)">取消</el-button>
					<el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 验证码 -->
		<el-dialog align-center v-model="captchaVisible" title="请输入图片中的验证码" width="380">
			<el-alert :title="alertText" type="warning" show-icon :closable="false" />
			<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style=" width: 240px; display: block;margin:15px auto;cursor: pointer;" />
		    <el-form>
		      <el-form-item label="验证码">
		        <el-input v-model="captchaAnswer" autocomplete="off" />
		      </el-form-item>
		    </el-form>
		    <template #footer>
		      <div class="dialog-footer">
		        <el-button type="primary" @click="captchaClick" style="font-size: 14px;">{{captchaBtn}}</el-button>
		      </div>
		    </template>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted,nextTick } from 'vue';
	import { fetchExample } from '@/api/users';
	import { fetchList,fetchAlarm,alarmCreate,alarmDelete,alarmSwitch } from '@/api/warning';
	import { captchaGet,smsCodeGet } from '@/api/home';
	import pageList from '../../components/pageList.vue'
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const fullscreenLoading = ref(false);
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const loading = ref(true);
	const searchInput = ref('');
	const captchaVisible = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const codeSendText = ref('短信验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const captchaBtn = ref('');
	const alertText = ref('');
	const editFlag = ref(false);
	const dialogGroupVisible = ref(false);
	const formLabelWidth = ref('150');
	const exampleOptions = ref();
	const filedOptions = ref();
	const typeText = ref('');
	const tableData = ref();
	const ruleFormRef = ref(null);
	const groupForm = ref({instance_id:'',alarm_name:'',fileds:'',maximum_value:'',minimum_value:'',code:''})
	const typeValidate = (rule, value, callback) => {
		if(typeText.value === 'float'){
			if (/^\d+(\.\d+)?$/.test(value)) {
				callback()
			}else{
				callback(new Error('请输入float类型的数值'))
			}
		}
		if(typeText.value === 'int'){
			if (/^\d+$/.test(value)) {
				callback()
			}else{
				callback(new Error('请输入int类型的数值'))
			}
		}
	};
	const rules = reactive({
		instance_id: [
			{ required: true, message: '请选择实例', trigger: 'blur' },
		],
		alarm_name: [
			{ required: true, message: '请填写推送规则名称', trigger: 'blur' },
		],
		fileds: [
			{ required: true, message: '请选择预警类型', trigger: 'blur' },
		],
		maximum_value: [
			{ required: true, message: '请填写最大值', trigger: 'blur' },
		],
		minimum_value: [
			{ required: true, message: '请填写最小值', trigger: 'blur' },
		],
		code: [
			{ required: true, message: '请填写短信验证码', trigger: 'blur' },
		]
	});
	const generData = () => {
		const param = {'page':1,'size':9999}
		fetchExample(param).then((res) => {
			exampleOptions.value = res.data.list;
		})
		fetchAlarm().then((res) => {
			filedOptions.value = res.data;
		})
	};
	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'search':searchInput.value
		}
		fetchList(param).then((res) => {
			paginationTotal.value = res.data.count;
			tableData.value = res.data.list;
			loading.value = false;
		})
	};
	const filedChange = (val) =>{
		typeText.value = val.type;
		groupForm.value.maximum_value = '';
		groupForm.value.minimum_value = '';
	}
	const addChange = () => {
		dialogGroupVisible.value = !dialogGroupVisible.value;
		editFlag.value = false;
	}
	const rowOperation = (row, now) => {
		if(now == 'edit'){
			dialogGroupVisible.value = !dialogGroupVisible.value;
			editFlag.value = true;
			nextTick(() => {
			    Object.assign(groupForm.value,row);
				groupForm.value.fileds = filedOptions.value.find(item => item.name === row.filed_name)
				typeText.value = row.fileds.type;
			})	
		}
		if(now == 'delete'){
			const param = {"alarm_push_id": row.alarm_push_id}
			ElMessageBox.confirm(
				'确定要删除该规则吗？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				alarmDelete(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							type: 'success',
							message: res.msg,
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
	};
	const switchChange = (row,index) => {
		tableData.value[index].loading = true;
		const param = {'alarm_push_id':row.alarm_push_id}
		alarmSwitch(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
			}
			fetchListF()
		})
	}
	const captchaChange = () => {
		captchaGet().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const codeChange = () => {
		captchaChange()
		captchaAnswer.value = '';
		captchaId.value = '';
		captchaBtn.value = '发送验证码';
		captchaVisible.value = !captchaVisible.value;
	}
	const captchaClick = () => {
		const param = {
			'captcha_answer':captchaAnswer.value,
			'captcha_id':captchaId.value
		}
		smsCodeGet(param).then((res) => {
			if (res.code == 200) {
				codeSend.value = true;
				codeSendText.value = codeTime.value+'s后重新发送';
				let timer = setInterval(() => {
				   codeTime.value--;
				   codeSendText.value = codeTime.value + 's后重新发送';
				   if (codeTime.value < 0) {
					   clearInterval(timer);
					   codeSendText.value = '获取验证码';
					   codeTime.value = 60;
					   codeSend.value = false
				   }
				}, 1000)
				captchaVisible.value = !captchaVisible.value;
			}
		})
	}
	const submitForm = () => {
	  if (!ruleFormRef.value) return;
	  ruleFormRef.value.validate((valid) => {
	    if (valid) {
			fullscreenLoading.value = true;
			groupForm.value.filed_name = groupForm.value.fileds.name;
			groupForm.value.maximum_value = parseInt(groupForm.value.maximum_value);
			groupForm.value.minimum_value = parseInt(groupForm.value.minimum_value);
			groupForm.value.status = groupForm.value.status ? '已启用':'未启用';
			const param = groupForm.value;
			alarmCreate(param).then((res) => {
				if(res.code === 200){
					ElMessage({
						offset:70,
						message: res.msg,
						type: 'success'
					})
					resetForm()
					fetchListF()
				}
				fullscreenLoading.value = false;
			})
	    } else {
	      return false;
	    }
	  });
	};
	const captchaReload = () => {
		captchaChange()
	}
	const resetForm = () => {
		groupForm.value = {instance_id:'',alarm_name:'',fileds:'',maximum_value:'',minimum_value:'',phone:''};
		ruleFormRef.value.resetFields();
		dialogGroupVisible.value = !dialogGroupVisible.value;
	}
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF();
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF();
	};
	const searchClick = () => {
		fetchListF()
	};
	const handleEmpty = () => {
		fetchListF()
	};
	
	onMounted(() => {
		alertText.value = '提示：接收验证码的手机号码为 ' + localStorage.getItem('smsPhone');
		generData()
		fetchListF();
	})
	
	
</script>

<style lang="scss" scoped>
	.search-main{float: right;}
	.type{
		.text{color: #888;margin-left: 10px;}
		.el-input{width: 50% !important;}
	}
</style>